import { CurrencyCell } from 'components';
import { AdjustmentType } from 'enums';
import { AdjustmentCategoryGridProps } from 'types';

const props: AdjustmentCategoryGridProps = {
    category: AdjustmentType.DotCreditToSupplier,
    adjustmentTypes: [AdjustmentType.DotCreditToSupplier],
    title: 'Dot Credit to Supplier',
    dataItemKey: 'rowNumber',
    selectMode: 'multiple',
    selectionGroupField: 'invoiceId',
    selectionGroupTitle: 'Credit Number',
    gridColumns: [
        {
            field: 'invoiceId',
            title: 'Credit Number',
            filterTitle: 'text'
        },
        {
            field: 'billTypeDesc',
            title: 'Type',
            filterTitle: 'text'
        },
        {
            field: 'paymentDate',
            title: 'Date',
            format: '{0:MMMM d, yyyy}',
            filterTitle: 'date'
        },
        {
            field: 'adjustmentAmount',
            title: 'Amount',
            cell: CurrencyCell,
            filterTitle: 'numeric'
        }
    ]
}
export default props;
